// headers.tsx - Fixed with Routing
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from "../assets/Icon 256.png";
import "../css/header.css";
import { Button, IconButton, Typography } from '@mui/material';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Navigation items configuration
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/contact', label: 'Contact' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Products' },
  ];

  // Handle logo click
  const handleLogoClick = () => {
    console.log('Logo clicked - redirecting to home');
    navigate('/');
    window.scrollTo(0, 0);
  };

  // Check if current path is active
  const isActivePath = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Left Section - Logo */}
        <div className="footer-left">
          <div className="logo-link" onClick={handleLogoClick}>
            <img
              src={logo}
              className="footerImg"
              alt="RonCafeSuite Logo"
            />
            <span className="logo-text">RonCafeSuite</span>
          </div>
        </div>

        {/* Center Section - Navigation */}
        <nav className="footer-nav">
          <ul className="nav-list">
            <Typography variant="body2" color="textSecondary">
              © 2026 RonCafeSuite. All rights reserved.
            </Typography>
            <Button onClick={() => window.open('https://github.com/RMPlaysMCYT/RonCafeApp', '_blank')} variant="text" color="inherit">
              <Typography variant="body2" color="textSecondary">
                Source Code.
              </Typography>
            </Button>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;